import { render, staticRenderFns } from "./MarketingEmailCreateContent.vue?vue&type=template&id=3b413095&scoped=true"
import script from "./MarketingEmailCreateContent.vue?vue&type=script&lang=js"
export * from "./MarketingEmailCreateContent.vue?vue&type=script&lang=js"
import style0 from "./MarketingEmailCreateContent.vue?vue&type=style&index=0&id=3b413095&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b413095",
  null
  
)

export default component.exports